import { render, staticRenderFns } from "./NotificationsTagListItem.vue?vue&type=template&id=48ea3d47&scoped=true&"
import script from "./NotificationsTagListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsTagListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsTagListItem.vue?vue&type=style&index=0&id=48ea3d47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea3d47",
  null
  
)

/* custom blocks */
import block0 from "./NotificationsTagListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports